const _center = true
const _padding = "1rem"
const config = { "center": _center, "padding": _padding,  }
export { config as default, _center, _padding }